export const signupListTypeOptions = [
  {
    ID: 1,
    label: "General Event",
    icon: "calendar-alt",
    text: "Create a Signup for a general event and allow members to list other members of their party.",
    hasFundItText: "You can collect registration fees for classes or retreats.",
    needsFundItText:
      "When you enable Fund It, you can collect registration fees for classes or retreats.",
  },
  {
    ID: 2,
    label: "Tickets or Seats",
    icon: "ticket",
    text: "Create a Signup for your members to reserve seats",
    hasFundItText: "or buy tickets to an event.",
    needsFundItText: "or buy tickets to an event when Fund It is enabled.",
  },
  {
    ID: 4,
    label: "Simple Selection or Poll",
    icon: "check-square",
    text: "Create a Signup to allow items or shifts to be selected without slots.",
    hasFundItText: "This works great for a quick poll or fundraiser.",
    needsFundItText:
      "This works great for a quick poll or fundraiser if Fund It is enabled.",
  },
  {
    ID: 5,
    label: "Items",
    icon: "tasks",
    text: "Allow volunteers to sign up to bring a specific item. Great for potlucks and class parties!",
    hasFundItText:
      "You can collect money for pizza or fish frys, sell t-shirts, and more!",
    needsFundItText:
      "When you enable Fund It, you can collect money for pizza or fish frys, sell t-shirts, and more!",
  },
  {
    ID: 7,
    label: "Volunteer Scheduling",
    icon: "users",
    text: "Create a Signup for specific time slots or tasks for volunteers.",
  },
];
